import { render } from "./CommunityComment.vue?vue&type=template&id=7b968c24&scoped=true"
import script from "./CommunityComment.vue?vue&type=script&lang=js"
export * from "./CommunityComment.vue?vue&type=script&lang=js"

import "./CommunityComment.vue?vue&type=style&index=0&id=7b968c24&lang=scss&scoped=true"
import "./CommunityComment.vue?vue&type=style&index=1&id=7b968c24&lang=scss"

import exportComponent from "/home/aloco/alocohawaii.com/moa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b968c24"]])

export default __exports__